export const API_URL = process.env.REACT_APP_API_URL || "";
export const JSON_URL = process.env.REACT_APP_JSON_URL || "";
export const CONTENT_JSON_URL = process.env.REACT_APP_CONTENT_JSON_URL || "";
export const BASE_URL = process.env.REACT_APP_BASE_URL || "/";
export const SENTRY_DSN_URL = process.env.REACT_APP_SENTRY_DSN_URL;
export const SHARE_URL = process.env.REACT_APP_SHARE_URL || "";
export const IMAGES_URL = process.env.REACT_APP_IMAGES_URL || "";

export const BASE_DOMAIN = process.env.REACT_APP_BASE_DOMAIN || "";

export const SYNDICATION_PREFIX = process.env.REACT_APP_SYNDICATION_PREFIX || "";

export const EMAIL_REGEXP = "\\S+@\\S+\\.\\S+";
export const PASSWORD_PATTERN =
	"^((?=.*?\\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[\\-!@#$%^&*\\(\\)_+\\|~=`\\{\\}\\[\\]:\";'<>?,.\\/])).{8,}$";

export const PASSWORD_REQUIREMENTS =
	"Password must include 8 characters, including 1 upper case character, 1 number and 1 special character";

export const FACEBOOK_ID = process.env.REACT_APP_FACEBOOK_APP_ID || false;

export const IS_SSO_BACKDOOR = JSON.parse(process.env.REACT_APP_IS_BACKDOOR || "false") as boolean;

const ALLOWED_LANGUAGES_STRING = process.env.REACT_APP_ALLOWED_LANGS || "en,es";
export const ALLOWED_LANGUAGES = ALLOWED_LANGUAGES_STRING.split(",").map((lang) => lang.trim());

export const SPECIAL_SYMBOLS = {
	ä: "a",
	Ä: "A",
	ö: "o",
	ó: "o",
	Ö: "O",
	ü: "u",
	Ü: "U",
	á: "a",
	í: "i",
	é: "e",
	å: "a",
	ß: "b",
};

export const INTERVAL = 60 * 1000;

export const TERMS_LINK_EN = process.env.REACT_APP_TERMS_LINK_EN || "";
export const TERMS_LINK_ES = process.env.REACT_APP_TERMS_LINK_ES || "";
